import LocalMerchant from '@components/LocalMerchant'
import home from './home'
import setMeal from './setMeal'
import xiu_yan from './xiu_yan'
import shou_xie from './shou_xie'
import cashier from './cashier'
import notice from './notice'
import introPages from './introPages'
import decoration from './decoration'
import liveManage from './liveManage'
import taskCenter from './taskCenter'
import jiaMeng from './jiaMeng'
import setting from './setting'
import certification from './certification'
import vr from './vr' // vr
import nameCard from './merchantNameCard' //海草名片小程序
import brand from './brand' // 品牌页配置
import sida from './sida'
import hotel from './hotel'
import multiStore from './multiStore'
import microleaflets from './microleaflets'
import easyChat from './easyChat'
import activityRegister from './activityRegister'
import marketingCenter from './marketingCenter'
import customerRecommendation from './customerRecommendation'
import systemAnnouncement from './systemAnnouncement'
import dynamic from './dynamic'
import potentialCustomers from './potentialCustomers'
import topicDetails from './topicDetails'
import contentCenter from './contentCenter'
import contentManage from './contentManage'
import popularization from './popularization'
import creativeCenter from './creativeCenter'
import ossm from './ossm'
import purchaseHistory from './purchaseHistory'
import coupons from './coupons'
import myCoupon from './myCoupon'
import skyEyeSystem from './skyEyeSystem'
import data from './data'
import management from './management'
import shop from './shop'
import chaohunjie from './chaohunjie'
import staff from './staff'
import contractSign from './contractSign'
import addressStyle from './addressStyle'
import customService from './customService'
import rhinocerosAcademy from './rhinocerosAcademy'
import serviceConfig from './serviceConfig'
import upgradeService from './upgradeService'
import siYiTeamGroupMember from './siYiTeamGroupMember'

export default {
  path: 'localMerchant',
  component: LocalMerchant,
  indexRoute: {
    onEnter(ns, replace) {
      replace('/localMerchant/home')
    }
  },
  childRoutes: [
    home,
    ...xiu_yan,
    ...shou_xie,
    setMeal,
    ...setting,
    ...cashier,
    notice,
    introPages,
    decoration,
    liveManage,
    taskCenter,
    ...jiaMeng,
    certification,
    vr,
    ...nameCard,
    brand,
    ...sida,
    ...hotel,
    multiStore,
    microleaflets,
    easyChat,
    activityRegister,
    marketingCenter,
    customerRecommendation,
    systemAnnouncement,
    dynamic,
    ...potentialCustomers,
    topicDetails,
    ...contentCenter,
    ...contentManage,
    ...popularization,
    creativeCenter,
    ...ossm,
    purchaseHistory,
    myCoupon,
    ...skyEyeSystem,
    coupons,
    ...data,
    ...shop,
    ...management,
    myCoupon,
    ...chaohunjie,
    staff,
    contractSign,
    addressStyle,
    customService,
    rhinocerosAcademy,
    ...serviceConfig,
    ...upgradeService,
    ...siYiTeamGroupMember
  ]
}
